/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateStatusNotification: BridgeCommands.Command<
    {},
    Types.Gfn.Gfnupdater.UpdateStatusInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GfnUpdater',
    method: 'UpdateStatusNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CheckForUpdates: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GfnUpdater',
    method: 'CheckForUpdates',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ResumeUpdate: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GfnUpdater',
    method: 'ResumeUpdate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PauseUpdate: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GfnUpdater',
    method: 'PauseUpdate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUpdateCheckErrorStatus: BridgeCommands.Command<
    {},
    Types.Gfn.Gfnupdater.GetUpdateCheckErrorStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GfnUpdater',
    method: 'GetUpdateCheckErrorStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLastInstallerStatus: BridgeCommands.Command<
    {},
    Types.Gfn.Gfnupdater.InstallerStatus
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GfnUpdater',
    method: 'GetLastInstallerStatus',
    persistent: false
};

export const Gfnupdater = {
UpdateStatusNotification,
CheckForUpdates,
ResumeUpdate,
PauseUpdate,
GetUpdateCheckErrorStatus,
GetLastInstallerStatus
};
